import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import InputBase from "@mui/material/InputBase";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import { FormHelperText, InputAdornment } from "@mui/material";
import { styled } from "@mui/system";
import { Search } from "@mui/icons-material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";

const BootstrapInput = styled(InputBase)(
  ({ theme, $isPassword, $isVerifyEmail }) => ({
    width: "100%",
    "label + &": {
      marginTop: theme.spacing(3),
    },
    "&.Mui-error .MuiInputBase-input": {
      border: "1px solid",
      borderColor: "red",
    },
    "& .MuiInputBase-input": {
      borderRadius: "10px",
      border: "1px solid #0832DE",
      height: "30px",
      width: "100%",
      fontSize: "16px",
      fontWeight: 400,
      color: "#365462",
      padding: $isPassword
        ? "9px 45px 9px 9px"
        : $isVerifyEmail
        ? "9px 50px 9px 9px"
        : "9px 14px",
      backgroundColor: "transparent",
    },
  })
);

const getCategoryIcon = (addSubCategory, disableCategory, name) => {
  return (
    <InputAdornment>
      <AddCircleOutlineIcon
        fontSize="small"
        disabled={disableCategory}
        sx={{
          cursor: "pointer",
          color: "#0832DE",
          position: "absolute",
          right: "15px",
          opacity: disableCategory ? "0.4" : "1",
        }}
        onClick={() => addSubCategory(name)}
      />
    </InputAdornment>
  );
};

const getEndAdornment = (type, showPassword, togglePasswordVisiblity) => {
  if (type === "password") {
    return (
      <InputAdornment>
        {showPassword ? (
          <VisibilityOffOutlinedIcon
            fontSize="small"
            sx={{
              cursor: "pointer",
              color: "#365462",
              position: "absolute",
              right: "15px",
              opacity: "0.4",
            }}
            onClick={togglePasswordVisiblity}
          />
        ) : (
          <VisibilityOutlinedIcon
            fontSize="small"
            sx={{
              cursor: "pointer",
              color: "#365462",
              position: "absolute",
              right: "15px",
              opacity: "0.4",
            }}
            onClick={togglePasswordVisiblity}
          />
        )}
      </InputAdornment>
    );
  } else return null;
};

function CustomTextField({
  name,
  variant,
  type,
  onChange,
  value,
  placeholder,
  errorMessage,
  className,
  onMouseLeave,
  isCategory,
  addSubCategory,
  disableCategory,
  isVerifyEmail,
  onBlur,
  disabled = false,
  ...props
}) {
  const [showPassword, setShowPassword] = useState(false);
  const togglePasswordVisiblity = () => setShowPassword(!showPassword);
  return (
    <>
      <BootstrapInput
        variant={variant}
        id={name}
        name={name}
        onBlur={onBlur}
        onMouseLeave={onMouseLeave}
        type={!showPassword ? type : "text"}
        onChange={onChange}
        value={value}
        placeholder={placeholder}
        disabled={disabled}
        className={className}
        $isPassword={type === "password"}
        $isVerifyEmail={isVerifyEmail}
        error={Boolean(errorMessage)}
        autoComplete="off"
        {...props}
        startAdornment={
          type === "search" ? (
            <InputAdornment
              fontSize="small"
              sx={{
                cursor: "pointer",
                color: "#0832DE",
                position: "absolute",
                left: "15px",
              }}
            >
              <Search fill="#0832DE" />
            </InputAdornment>
          ) : null
        }
        endAdornment={
          isCategory ? (
            <></>
          ) : (
            getEndAdornment(type, showPassword, togglePasswordVisiblity)
          )
        }
      />
      {errorMessage && (
        <FormHelperText
          sx={{ color: "error.main", fontSize: "11px", fontWeight: 400 }}
        >
          {errorMessage}
        </FormHelperText>
      )}
    </>
  );
}

export default CustomTextField;

CustomTextField.propTypes = {
  variant: PropTypes.string,
  type: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
};
